var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"col-11 col-sm-7 col-md-5 col-lg-4 col-xl-3 mt-10"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }